export const Languages = {
  es_es : 'es_es',
  pt_br : 'pt_br',
  en_us : 'en_us',
};

export const LanguagesWithoutRegion = {
  es : 'es_es',
  pt : 'pt_br',
  en : 'en_us'
};

export const Locale = {
  BRL : 'pt_br',
  EUR : 'es_es',
  URY : 'es_es',
  UYU : 'es_uy',
};

type LanguagesValuesType = typeof Languages[keyof typeof Languages];

type LocaleKeysTypes = typeof Locale[keyof typeof Locale];

export type { LanguagesValuesType, LocaleKeysTypes };
